import { BCMSRecord, NavLink, Outlet, useBCMSContext, useModel, useRouteData, useStateManager } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";
import { CheckmarkBanner } from "components/shared/views/ConfirmBannerView";
import CustomContentHeaderWidget from "components/shared/views/CustomContentHeaderWidget";
import Classes, { TransferTransaction } from "model";
import PendingApprovalPage from "./components/PendingApprovalPage";
import "./styles.css";
import "./mobile.css";


export default function TransferActivityPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
    const className = props.className?(" "+props.className):"";

    const state = { data, ui };
    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui
    });

    return (
        <PageContainer className={"transfer-activity-page"+className} state={ state } controller={ controller }>
            <TransferActivityContent />
        </PageContainer>
    )
}

export const getDefaultPageData = () => ({
  scheduledTransfers: TransferTransaction.initAll().filter(item => item.id !== undefined).filter(transfer => transfer.status === "scheduled", []),
  pendingApprovalTransfers: TransferTransaction.initAll().filter(item => item.id !== undefined).filter(transfer => transfer.needsApproval, []),
});
export const getDefaultPageUI = () => ({
  content: undefined,

  scheduledTransfers: { isActive: false },
  transferHistory: { isActive: false },
  pendingApproval: { isActive: false }
});

function TransferActivityContent(props) {
    const { data, ui } = useStateManager();
    const Component = ui.content;
    const { branding } = useModel();
    const { options } = branding;
    const { route } = useRouteData();
    const transferUpdated = route ? route.transferUpdated === "true" : false;
    const subHeaderContent = options.transfer_activity_subheader_abi22;
    const promoText = options.transfer_activity_promo_abi22;
    const subfooterText = options.transferactivity_subfooter_abi22;
    const pendingApprovalTransfers = data.pendingApprovalTransfers;
    const hasPendingApprovalTransfers = pendingApprovalTransfers.length > 0;
    let transfers = data.scheduledTransfers;

    if(Component === PendingApprovalPage && hasPendingApprovalTransfers) {
      transfers = pendingApprovalTransfers;
    }

    if(route) window.history.replaceState({}, document.title);

    return (
        <PageContentView>
          <div className="flex-container flex-vertical page-widget-wrapper">
            {promoText && <CustomContentHeaderWidget content = {promoText}/>}
            
            <CenterContentContainer>
                <ContentHeaderView text="Transfer Activity" />
                {subHeaderContent && <CustomContentHeaderWidget content = {subHeaderContent}/>}
                { transferUpdated &&
                    <CheckmarkBanner text="Your transfer has been successfully updated." />
                }
                <TransferActivityTabsView />

                { ui.content === undefined ? <Outlet /> : <Component transfers={ transfers } /> }
            </CenterContentContainer>
            { subfooterText && <CustomContentHeaderWidget content={ subfooterText } /> }
          </div>
        </PageContentView>
    )
}

function TransferActivityTabsView(props) {
    const { data, ui } = useStateManager();
    
    const scheduledActive = ui.content !== undefined && ui.scheduledTransfers.isActive ? "active-item" : "";
    const transferActive = ui.content !== undefined && ui.transferHistory.isActive ? "active-item" : "";
    const pendingApprovalActive = ui.content !== undefined && ui.pendingApproval.isActive ? "active-item" : "";
    const pendingApprovalTransfers = data.pendingApprovalTransfers;
    const hasPendingApprovalTransfers = pendingApprovalTransfers.length > 0;

    return(
      <div className="transfer-activity-tabs-view flex-container">        
        <NavLink dataPoint="Transfer_Activity_Scheduled" className={`tab set-width ${ scheduledActive }`} activeClassName="active-item" activeRoutes={["/transferActivity/scheduledTransfers"]} to="/transferActivity/scheduledTransfers">
          SCHEDULED
        </NavLink>
        <NavLink dataPoint="Transfer_Activity_History" className={`tab set-width ${ transferActive }`} activeClassName="active-item" activeRoutes={["/transferActivity/transferHistory"]} to="/transferActivity/transferHistory">
          HISTORY
        </NavLink>
        { hasPendingApprovalTransfers && 
        <NavLink dataPoint="Transfer_Activity_Pending_Approvals" className={`tab set-width pending-approval-tab ${ pendingApprovalActive }`} activeClassName="active-item" activeRoutes={["/transferActivity/pendingApproval"]} to="/transferActivity/pendingApproval">
          <div className="flex-container flex-horizontal align-center pending-approvals-tab-content flex-width">
            <p>PENDING APPROVAL</p>
            <div className="notification-bubble set-width show-on-desktop">
              { pendingApprovalTransfers.length }
            </div>
            <div className="mobile-notification-dot set-width show-on-mobile"></div>
          </div>
        </NavLink>
        }
      </div>
    );
  }